module.exports = __webpack_public_path__ + "static/img/LT@2x.35b563f1.jpg";